import Marionette from "backbone.marionette";
import MetaView from "../../meta/drg-deletes";
import Form from "./form";
import templates from "../../../../utils/templates";

const DEFAULTS = {
  tagName: "form",
  template: templates.find("chart_reviews", "chart_edit_drg_layout"),
};

class View extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  childEvents() {
    return {
      "modal:close": "_hide",
    };
  }

  initialize() {
    // localize api and chart models passed in via options
    this.apiModel = this.options.data.apiModel || null;
    this.chartModel = this.options.data.chartModel || null;
  }

  regions() {
    return {
      meta: ".chart-review-meta",
      form: ".drg-list",
    };
  }

  onBeforeShow() {
    this.meta.show(
      new MetaView({
        model: this.chartModel,
        memberCategories: this.model.get("memberCategories"),
      })
    );

    this.form.show(
      new Form({
        model: this.model,
        apiModel: this.apiModel,
      })
    );
  }

  _hide() {
    // notify parent layout of this change
    this.triggerMethod("modal:close");
  }
}

export { View as default };
